import appConstants from '../constants';
import fetchService from './fetchService';

const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_GET_PARTNER_USER_SAVED_COUNT_URL}`;

// {
//     "data": {
//         "favPartnerCountList": [
//             {
//                 "siteId": "1200",
//                 "partnerCount": "2",
//                 "begeoId": "4565"
//             }
//         ]
//     },
//     "success": "true",
//     "message": "FAVORITE PARTNERS COUNT RETRIEVED SUCCESSFULLY"
// }

function processData(data) {
  let processedData = [];
  if (!!data && 'favPartnerCountList' in data) {
    processedData = data.favPartnerCountList;
  }
  return {
    hasError: false,
    errorMessage: null,
    partnerUserSavedCounts: processedData
  }
}

export default async function fetchPartnerUserSavedCounts(partnerSiteIdListAsString) {
  let fetchedDataObject = await fetchService(
      'fetchPartnerUserSavedCounts',
      SERVICE_URL,
      {
        ...appConstants.SERVICE_REQUEST_GET_PARTNER_USER_SAVED_COUNT_CONFIG,
        body: JSON.stringify({
          siteIdList: partnerSiteIdListAsString
        })
      }
    );
  return !fetchedDataObject.success ?
    {
      hasError: true,
      errorMessage: fetchedDataObject.statusMessage,
      partnerUserSavedCounts: {}
    } :
    processData(fetchedDataObject.data);
}
